import { render, staticRenderFns } from "./DigitalContractsList.vue?vue&type=template&id=5e4e6f1d&scoped=true"
import script from "./DigitalContractsList.vue?vue&type=script&lang=js"
export * from "./DigitalContractsList.vue?vue&type=script&lang=js"
import style0 from "./DigitalContractsList.vue?vue&type=style&index=0&id=5e4e6f1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4e6f1d",
  null
  
)

export default component.exports